<!--  -->
<template>
  <div class="information-registration">
    <div class="prayer-container">
      <div class="title-container"
           v-if="$route.name == 'xinxidengji' || $route.name == 'DonationRegistration'||$route.name == 'huodongdengji'">
        <div class="prayer-title">信息登记</div>
      </div>
      <div class="contact-select-block"
           v-if="$route.name == 'xinxidengji' || $route.name == 'DonationRegistration'|| $route.name == 'huodongdengji'">
        <div v-for="(userInfo, index) in userList"
             :key="index"
             class="contact-item-wrap">
          <div v-if="1 <= userList.length"
               class="contact-item"
               :class="getButtonClass(index)"
               @click="contactItemSelected(userInfo, index)">
            {{ userInfo.name | truncateText }}
          </div>
        </div>
        <div class="more-contact"
             @click="addUser = true">
          <img src="../assets/xinzeng.png"
               alt="more">
          {{ addUserList.length > 3 ? "新增/更多" : "新增" }}
        </div>
      </div>
      <div class="contact-card"
           v-if="!showContactCard">
        <div class="item-left"
             @click="closeUserInfoBox()"></div>
        <div class="item-middle">
          <div class="card-cell-name">{{ showResult?.name }}</div>
          <div class="card-cell">
            <span class="card-title">手机号</span>{{ showResult?.phone | phoneMask }}
          </div>
          <div class="card-cell">
            <span class="card-title">阳历生日</span>{{ showResult?.birthday }}
          </div>
          <div class="card-cell">
            <span class="card-title">时辰</span>{{ showResult?.times }}
          </div>
          <div class="card-cell">
            <span class="card-title">性别</span>{{ showResult?.sex }}
          </div>
          <div class="card-cell">
            <span class="card-title">{{meetingInfo?.name?.includes('拜太岁') ? '邮寄地址' : '居住地址'}}</span>
            <span class="card-area">{{ showResult?.province + showResult?.city + showResult?.area + showResult?.address
              }}</span>
          </div>
        </div>
        <div class="item-right"
             @click="toEditUser(showResult)"></div>
      </div>
      <div v-if="showContactCard">
        <div class="cell">
          <van-field v-model="addUserInfo.name"
                     label="姓名"
                     :formatter="formatter"
                     placeholder="请输入姓名" />
        </div>
        <div class="cell">
          <van-field v-model="addUserInfo.phone"
                     type="tel"
                     label-align="left"
                     label="手机号码"
                     placeholder="请输入手机号码" />
        </div>
        <div class="cell">
          <van-field v-model="addUserInfo.birthday"
                     label-align="left"
                     label="阳历生日"
                     placeholder="请选择"
                     readonly="readonly"
                     @click="showPriceDetail = true, lunarCalendar = true" />
          <img src="../assets/jiantouyou.png"
               class="choose-arrow">
        </div>
        <div class="cell">
          <van-field v-model="addUserInfo.times"
                     label-align="left"
                     label="时辰"
                     placeholder="请选择"
                     readonly="readonly"
                     @click="showPriceDetail = true, shichen = true" />
          <img src="../assets/jiantouyou.png"
               class="choose-arrow">
        </div>
        <div class="cell">
          <van-field v-model="addUserInfo.sex"
                     label="性别"
                     placeholder="请选择"
                     readonly="readonly"
                     @click="showPriceDetail = true, isGender = true" />
          <img src="../assets/jiantouyou.png"
               class="choose-arrow">
        </div>
        <div class="cell">
          <van-field v-model="addressArr"
                     :label="meetingInfo?.name?.includes('拜太岁') ? '邮寄地址' : '居住地址'"
                     placeholder="请选择"
                     readonly="readonly"
                     @click="showPriceDetail = true, isaddress = true" />
          <img src="../assets/jiantouyou.png"
               class="choose-arrow">
        </div>
        <div class="cell-text-container">
          <van-field autosize
                     type="address"
                     v-model="addUserInfo.address"
                     label="详细地址"
                     placeholder="如道路、门牌号、小区、楼栋号、单元…" />
        </div>
        <div class="contact-checkBox"
             style="margin: 12px 0px; text-align: right;"
             v-if="$route.name == 'xinxidengji' || $route.name == 'DonationRegistration'">
          <label>
            <van-checkbox class="regular-checkbox"
                          icon-size="12px"
                          checked-color="#007aaa"
                          v-model="checked">添加至常用信息</van-checkbox>
          </label>
        </div>
        <van-popup v-model="showPriceDetail"
                   position="bottom"
                   round
                   @click-overlay="lunarCalendar=false,isaddress=false,shichen=false,isGender=false">
          <van-datetime-picker class="time-style"
                               v-if="lunarCalendar"
                               v-model="currentDate"
                               type="date"
                               title=""
                               :min-date="minDate"
                               :max-date="maxDate"
                               @confirm="onlunarCalendar"
                               @cancel="showPriceDetail = false, lunarCalendar = false" />
          <!--阳历生日 -->
          <van-picker class="danxiang-style"
                      show-toolbar
                      v-if="shichen"
                      :columns="columns"
                      type="date"
                      title=""
                      @confirm="onShiChen"
                      @cancel="onCancel" /><!--时辰 -->

          <van-picker class="danxiang-style"
                      show-toolbar
                      v-if="isGender"
                      :columns="genderColumns"
                      v-model="gender"
                      type="date"
                      title=""
                      @confirm="onGender"
                      @cancel="onCancel2" /><!--性别 -->

          <van-area class="danxiang-style"
                    v-if="isaddress"
                    title=""
                    @confirm="onAreaList"
                    @cancel="onCancel3"
                    :area-list="areaList" /><!--地址 -->
        </van-popup>
      </div>
      <van-popup v-model="addUser"
                 position="bottom"
                 round>
        <div class="select-contact-container show-select-contact">
          <img @click="addUser = false"
               src="../assets/close.png"
               alt="close">
          <div class="select-contact-title">选择常用信息</div>
          <div class="scroll">
            <div class="increase"
                 @click="goUserAdd">
              <img src="../assets/xinzeng.png"
                   alt="add">
              新增
            </div>
            <div class="contact-wrap">
              <!-- <div v-for="(contact, index) in contacts" :key="index" class="contact-item"> -->
              <van-radio-group v-model="radio"
                               v-for="(contact, index) in addUserList"
                               :key="index"
                               class="contact-item">
                <div class="left">
                  <van-radio icon-size="16px"
                             checked-color="#007aaa"
                             :name="index"
                             @click="radioSelected(index)"></van-radio>
                </div>
                <div class="center"
                     style="text-align: left;">
                  <div>
                    <span class="name">{{ contact.name }}</span>
                  </div>
                  <div>
                    <span class="info-title">手机号码</span>
                    <span class="info-content">{{ contact.phone }}</span>
                  </div>
                </div>
                <div class="right">
                  <img src="../assets/xinxibianji.png"
                       alt="edit"
                       @click="toEditUser(contact)">
                </div>
              </van-radio-group>

              <!-- </div> -->
            </div>
          </div>
          <div class="bottom-wrap">
            <div class="confirm"
                 @click="addUser = false">确定</div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 创建当前日期对象
var currentDate = new Date();
// 获取当前年份、月份和日期
var year = currentDate.getFullYear();
var month = currentDate.getMonth() + 1;
var date = currentDate.getDate();
var previousDate = new Date(year, month - 1, date - 1);
var previousYear = previousDate.getFullYear();
var previousMonth = previousDate.getMonth() + 1;
var previousDay = previousDate.getDate();
previousMonth = previousMonth < 10 ? '0' + previousMonth : previousMonth;
previousDay = previousDay < 10 ? '0' + previousDay : previousDay;
var previousDateString = new Date(previousYear + '-' + previousMonth + '-' + previousDay);


import { areaList } from '@vant/area-data';
export default {
  name: "InformationRegistration",
  // import引入的组件需要注入到对象中才能使用
  components: {},

  props: {
    childData: {
      type: [Object, Boolean, String, Number],
      required: false
    }
  },
  data() {
    // 这里存放数据

    return {
      meetingInfo: {},
      addUserInfo: {},
      radio: null,
      userList: [],
      addUserList: [],
      showResult: {},
      addUser: false,
      areaList: areaList,
      lunarCalendar: false,
      shichen: false,
      minDate: new Date(1900, 0, 1),
      maxDate: previousDateString,
      currentDate: previousDateString,
      showPriceDetail: false,
      checked: true,
      name: "",
      phone: "",
      showContactCard: true,
      columns: ["吉时", "子时 23:00-01:00", "丑时 01:00-03:00", "寅时 03:00-05:00", "卯时 05:00-07:00", "辰时 07:00-09:00", "巳时 09:00-11:00", "午时 11:00-13:00", "未时 13:00-15:00", "申时 15:00-17:00", "酉时 17:00-19:00", "戌时 19:00-21:00", "亥时 21:00-23:00"],
      isGender: false,
      gender: '',
      genderColumns: ['男', '女'],
      isaddress: false,
      selectedIndex: null,
      addressArr: "",
      addUserInfo: {
        address: "",
        area: "",
        birthday: "",
        city: "",
        code: "",
        createBy: "",
        createTime: "",
        id: null,
        isCreate: true,
        name: "",
        openId: "",
        phone: "",
        phoneExt: "",
        photo: "",
        province: "",
        sex: "",
        times: "",
        updateBy: "",
        updateTime: "",

      }
    }
  },
  filters: {
    truncateText(text) {
      if (text.length > 3) {
        return text.substring(0, 3) + '...';
      }
      return text;
    },
    phoneMask(phone) {
      if (phone && phone.length >= 11) {
        return phone.substring(0, 3) + '****' + phone.substring(phone.length - 4);
      }
      return phone;
    }
  },
  // 监听属性 类似于data概念
  computed: {

  },
  // 监控data中的数据变化
  watch: {
  },
  // 方法集合
  methods: {
    formatter(value) {
      // 过滤输入的数字
      return value.replace(/\d/g, '');
    },
    toEditUser(editUser) {
      this.$router.push({
        name: "userAdd",
        params: {
          editUser: editUser,
          path: this.$route.name,
          selectedIndex: this.selectedIndex
        },
      })
    },
    closeUserInfoBox() {
      localStorage.setItem("isAddUser", true)
      this.showContactCard = true
      this.selectedIndex = null
      this.radio = null
    },
    //选择联系人按钮事件
    contactItemSelected(userInfo, index) {
      this.checked = false
      this.showResult = userInfo
      this.selectedIndex = index
      this.showContactCard = false
      this.addUserInfo = userInfo
      this.radio = index
      localStorage.setItem("addUserId", this.addUserInfo.id)
      localStorage.setItem("isAddUser", false)
    },
    radioSelected(index) {
      this.showResult = this.addUserList[index]
      this.selectedIndex = index
      if ((index > 2 || index == 0) && this.addUserList.length >= 4) {
        let info = this.addUserList[index]
        this.$set(this.userList, 0, info);
      }
      this.addUserInfo = this.addUserList[index]
      this.showContactCard = false
    },
    getButtonClass(index) {
      return this.selectedIndex === index ? 'contact-item-selected' : '';
    },
    goUserAdd() {
      this.$router.push({
        name: "userAdd",
        params: {
          editUser: false,
          path: this.$route.name,
        },
      })
    },
    onShiChen(value, index) {
      this.addUserInfo.times = value
      this.showPriceDetail = false
      this.shichen = false
    },
    onCancel(date) {
      this.showPriceDetail = false
      this.shichen = false
    },
    onCancel2(date) {
      this.showPriceDetail = false
      this.isGender = false
    },
    onCancel3(date) {
      this.showPriceDetail = false
      this.isaddress = false
    },
    onGender(value, index) {
      this.addUserInfo.sex = value
      this.showPriceDetail = false
      this.isGender = false
    },
    onAreaList(value) {
      this.addUserInfo.province = value[0].name
      this.addUserInfo.city = value[1].name
      this.addUserInfo.area = value[2].name
      this.addressArr = value[0].name + value[1].name + value[2].name
      this.showPriceDetail = false
      this.isaddress = false
    },

    onlunarCalendar(value, index) {
      // 创建一个Date对象，传入给定的时间字符串
      const dateStr = value;
      const date = new Date(dateStr);
      // 获取年、月、日
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份需要加1，且补零操作
      const day = String(date.getDate()).padStart(2, '0');
      // 拼接成想要的格式
      const formattedDate = `${year}-${month}-${day}`;
      this.addUserInfo.birthday = formattedDate
      this.showPriceDetail = false
      this.lunarCalendar = false
    },


    async getUserData() {
      try {
        const data = await this.$http.get('/tempt/api/sjte/getUers'); // 通过this.$http调用全局挂载的axios实例发送GET请求，这里的/api/some-endpoint根据实际后端接口调整
        this.userList = data.result.slice(0, 3)
        this.$store.commit("updateUserInfoList", this.userList);
        this.addUserList = data.result
        if ((typeof this.childData == "number") || (typeof this.childData == "string")) {
          this.selectedIndex = this.childData
          this.radioSelected(this.selectedIndex)
          this.radio = this.childData
        }
      } catch (error) {
        this.userList = error.result.slice(0, 3)
        this.$store.commit("updateUserInfoList", this.userList);
        this.addUserList = error.result
        console.log("error111")
      } finally {
        console.log("error22222")
      }
    },
  },
  // 生命周期-创建完成（可以访问当前this实例）
  created() {
    localStorage.setItem("isAddUser", true)
    if (this.childData === false) {
      this.getUserData()
    } else if ((typeof this.childData == "number") || (typeof this.childData == "string")) {
      this.getUserData(this.childData)

    } else {
      this.addUserInfo = this.childData
      this.selectedIndex = this.childData.selectedIndex
      this.addressArr = this.childData.province + this.childData.city + this.childData.area
    }
    this.meetingInfo = this.$store.state.meetingInfo.__ob__ ? JSON.parse(localStorage.getItem("meetingInfo")) : this.$store.state.meetingInfo

  },
  // 生命周期-挂载完成（可以访问DOM元素）
  mounted() {

  },

  beforeCreate() { }, // 生命周期-创建之前
  beforeMount() { }, // 生命周期-挂载之前
  beforeUpdate() { }, // 生命周期-更新之前
  updated() { }, // 生命周期-更新之后
  beforeDestroy() { }, // 生命周期-销毁之前
  destroyed() { }, // 生命周期-销毁完成
  activated() { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.contact-select-block {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin: 8px 0;
  -webkit-column-gap: 5px;
  -moz-column-gap: 5px;
  column-gap: 5px;
  grid-column-gap: 5px;
}

/* 更多联系人按钮样式 */
.contact-item-selected {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACAklEQVRIS7WUT0gUYRjGf++2q4IpgUVdukSXDtFRD3ZRgqDoUDQieegQCUHRZU1nCbZwF6SORVR0kqCdRUxBL13sVpHgpcCDhzpEZLTiLii77r4xq2Iz+2fGbXau3/M9v/d553tfwe8Xtw5S4AJKH3AGOAHSCdpaz0I8/Uetk4T0Hsgg0O6pdwlqA27Pt9KZfYjKXaBlv8a7+uqAqHWMCNNAT6PGtQH3rdMUmQOO/6+5fd+ZYLvyT0GZOwF2zztyC0G05d/kewliqQlURoJoSyWg/BT50uBryaA6S0iOopx3F7idwEy9BLnRQPU5pHSOyMYShfa5nSF02Aj2hOb52cAQbRKWi4QOvye/OgVcqlagELMGUN5UHCpFpAxuA7pc51uoXiVpzGBak4hcq5VeMK3nwM0qggwa7iHX9o2OnD0X/TuaEsJ1EsYkZvop6K36u8i0PgDdNUTfkWIvmQMZDvEOpBvROySMJ5ipJMiY13+zE/wCjtQRLqOcRQtbhCOXGTdeEUuPoDrhZQ5kBTO96bVyERYJ5/t4MLTOWHoY0WcVW6A6bdlOoD4qsSUfQRagFAUJ+boj8no/AF+eziEQo4kAXeH32qkmAUQRvULCmG4SgEckjfLiDBggCvqYlq+jxOOlgAG6gkjUbotzXft/pu5XlAV+IPIZmGH1z1teDBfcor8U96Nek6aSIwAAAABJRU5ErkJggg==);
  background-repeat: no-repeat;
  background-position: right -1px bottom;
  background-size: 12px;
  color: #007aaa;
  background-color: rgba(0, 122, 170, 0.05);
  border: 1px solid #007aaa;
}

.contact-select-block .contact-item {
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 12px;
  font-weight: 400;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  height: 38px;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.more-contact {
  background-color: #fff;
  border-radius: 5px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #007aaa;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 38px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.more-contact img {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}

::v-deep .van-picker__toolbar {
  border-bottom: 1px solid #eaeaea;
  height: 45px;
}

::v-deep .van-picker__toolbar button {
  width: auto;
  line-height: 45px;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #007aaa;
  font-weight: 400;
}

::v-deep
  .time-style.van-picker
  .van-picker__columns
  .van-picker-column
  ul
  li
  .van-ellipsis {
  padding: 2px 10px;
  font-family: PingFangSC-Semibold;
  font-size: 20px;
  color: #007aaa;
  font-weight: 600;
}

::v-deep
  .danxiang-style.van-picker
  .van-picker__columns
  .van-picker-column
  ul
  .van-picker-column__item--selected
  .van-ellipsis {
  padding: 2px 10px;
  font-family: PingFangSC-Semibold;
  font-size: 20px;
  color: #007aaa;
  font-weight: 600;
}

/* 联系人卡片样式 */
.contact-card {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
}

.contact-card .item-left {
  width: 10%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFKklEQVRoQ92aR8idRRSGn9h7QxDsYkGjuLCDFbuCGDuEEOxlISi41YVuBQUXJnaCCJZYwa4YC4htITYs2EVB7L3zhDNh+Jyv3u+q14HLz8+dct4z7znnnZk7h3HbysBqwKrASvFxhT/i8yvwC/D7WMvOGWGiNYDNgc2ATYANgfWB1QOIS2j4z8DXwJfAp8AnwEfAT5PYMAmAtYD9gN2BjYA1M4PbbBLQj8AXwIvA08APbYNK3/cFYP8NgD2AI4B1C5NKDw30r9SxSSfpJbX8W23fAg8BLwBfAX92BdMHgB7W2/sDWwH5WGnwIfAx8HkYoUcFYtNwd0zwGwfdtgCkX2oa/T7wVOyKO9TaugJwoeOBfYLbaWINfxJ4Lox20d9aVl0l6CaYvYADKkCMlWeBO7vERxuARJn5wK5hmJ76HngNuCc83uqphg7uyLHAXGDtbGdfBm5po1QTAL/bHjgxKJNseAV4FHhzxHRoXOwAHArskoGVUrcDb9fFRRMA0+F5wJbhFQPyceAB4LtJXN4wdh3gKODgCHx3+wPg6ki/fxtaB0DOn5HRRq4/GJ5PgTklDMsD/rDIcinIpdP1pZgoATDbHAccGBbq+XuBRzoE6FigEohjsmq+DLgr6seKdaoA/H9f4OQs28j3u7OUOJaRbfMIYl7EhX3NTrcBz+TxUAUg788Fto5OrwI3TpHzbSCMidOAnSMO3wMW5fFQBSD3TojOBup1wOttq0z5+52AMwHBGNTWh4fTmjkAK+WlmTywON00YqocitMUe2oUPefQsRcn7ZQDODy8byezzmUNRcpx24ZX7K9n3F7VZpemWpWmaX2NeqdBA1nsLsnicmnahTSB6erCmFQDFFZuVV1TnJmppFya4w3g1pDJTSA2BU4BdoxOgpcSJook/krjpbZOtumsK3R0Wnw74BxgvfD+5SHOmgxR7x8Zhcd5XNzqfEPDTuj506Pq6gSNvz9qjAedpqb4uyh00zfAYit0AmDOPylU41vxpRK3rQlCHeN4RZrN8dcWQGj8WSFP7KfoeyL0VJvx9le662TljcVUibFMAAaJ23NIGOCkftmmKhM4s8PRUf7r6FSizWPhfYVhl6aDdPJB0dnxS13QyrsQ2C0yjtXOqtunNdHJeYbSpmqDMWfs6fSXgCUCkPcWL7OK2edm4Pk+1kffOjr5tds+hDZVM/YEFkQcmLUWJb1/fhzM3U5FkxV4SCvRKc1jwPalTdUGK7Ii03ODFwJXCcAD+QVxo2DgXhPZZAgAx7gTSmI/eVOGm3G6BGzd2p4Zzo6A/gy4choAqtkmGVOXnfo4qgjAs+lYFCplGw3sW+zqQBUpNFYQ1xUpjTHNdi12TTuSB7HHzMVjpdGmIqVBFjvzd1uxa6NTMY1OWsi6FCmzhrtgsRxKp9pCJuqhUqKPtvHSV+00lE61UkIAQ8TcEG0jiKF0ahRzfeW0mUv5YVaw9SlSJTpZOJfEJVZdHDTKaQf1OdBYrNw1D942rxTf7VGk3IltQoc5XnVpVvHgXmqtBxoHzcqRUrXg6Wz5dfwsHuo9Tq5Qy/+7a5WZv9iSVqWrxfti26Z9L5oCePDVYpqgdLnrTYXcmzaIiS93E4iZvl5PGeq/8MBxR9x0FB/+mh44Egir7kw+MeUV0cD2kW/vwiOf9/ZeAvg82veRT32vkMxfK0d95KuCmNln1gQk3WLoOR+6vYWotiEP3V7umuXSTk7lobtq6Ez+1KCkFIf82MMrEV/1/9Ufe5TA/OM/t/kLRKGwuAxtoj4AAAAASUVORK5CYII=);
  background-repeat: no-repeat;
  background-position: 0;
  background-size: 16px 16px;
}

.contact-card .item-middle {
  width: 80%;
}

.contact-card .item-middle .card-cell-name {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000;
  line-height: 20px;
  margin: 4px 0 6px;
}

.contact-card .item-middle .card-cell:not(:last-child) {
  margin-bottom: 4px;
}

.contact-card .item-middle .card-cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  line-height: 17px;
}

.contact-card .item-middle .card-cell .card-title {
  width: 48px;
  margin-right: 8px;
}

.contact-card .cell {
  line-height: 48px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-weight: 400;
}

.contact-card .item-right {
  width: 10%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFHUlEQVRoQ9WZW2xURRjHf3MuLOViuIYHsWgMSmIMUV7UgpcY7wIp0iW++ITBwIMBBXqBNEeQS0g0ETDxQhUDtN3dVkHii/KCDyZqNBpqND5oEBMRIxSp0O6e+cwpbffs7tnt2Uvb9Tye/Wb2/zvzn29mvlFUyyOi2No2DXvKDCwzgmsoUskkTO8l8lUvjqODpKqq0P/yB1OJRFagjCfRcjcwD4WJcBFFD6hTWEYC55lz2XonHqA1No2kOgTyOKjpIEGa+oEz2PZ6nPov/RATCCCKlu5axD0K1IVygjcahrGGHat7huMnDqCx/WZMaz8iTwCmD+Ai8D1K9YPcinALYIz8rvgMa+5ynIeuee8mBqDp8GzMmuNo7skS/ynoRgYmncPGxdSz0PIisBYkMgShMY3n2bG6bQIAhmyj3KNov21UCuQjbNbhRP/OsNMbn0Q4fyWOsNw3Cqexeh7GcVLjOwItXQtAHwiwTQLtbmbPs78GzoXt7Xfhmt/4fvsFlwfZGz07fgD5bfMbwhJ2Ry/kncgNMZOFXAKmDcX8jmk9xY5V340DQD7bZMh9H9veiFPvicx9dp+cyT///uWbzGcxeJSd0Z/GHiC/bfxCvTzfhm0350B4K/S22EuI2uebA2dIsZS90d6xBchnG2V0IroWuNdH4UG08zNriUfdkfctnfcj6ghwUxpA3uTVNRvGMAsVyDaKD7HkBVLUIBwFWQYqnechbaetHYuxjMMIi9Pi1SWsyGKcFWfHDiCfbZSK46a2jGSb7bE7cdkPPJA1Em0YxklE78oQj1zGMLaws+GtsVuJW2OzcDmRu0ipDmzZkJPnW2I3IsQD7NQHzPKBDaB4jdm8wqbo1TEAKGGRGlZxHSLITsMRA6DeY45s9IuvrIXy720KL1LDEj07adWOyB2ZeVT6wDjAHHGyxVcOIJ9thE4msT7HNkG5fntXHa7uAJmfYRvU69iyEyd6JahZmWm0DNv41QRlG8hrG3/T8gBK3dv4FTR11WG4BzOzDX2g8tqmMgCVsI0nXrmHgNuLsU2ZABNvm/IAqsA2pQNUiW1KAKgu2xQPUGW2KQ6gCm0TEqB6bRMOoIptMzpAoZOUpcPtbSqwSAXtfbLfZW0lRNHYsQDLPBK6bhP0L2XsbcKIzj8ChbbEtr0Zpz64blPBvU3pAP8j22SNQJXYprVrPq6sRNypoUZBGVdxzWMKL88n8Q7J9VmF1gTjaZuWeAMi7wI3hALwgkxZqmjqvg2V+hqYPtLQq9uMd7ZpTkRBv1MUgM0yRVNiEUp/C0weAviCJKvYF/1j1C9RyWzTEl+JcAAk7AgIpvFYEEACl7Ve2a4gQFNnHYYq+SSV03dTbC6Gug9Rw/cAhb+f0kmsgVPDAF7pumaoxegAnnjl3WuVfpIadXRDBhQPMGgbdRhR6XJfyAN4SE1FhRUHMGgbDmaJD30AL0pZyODcOaDUSdya59jztHfZln4G6zblHcBDaioqLGgSC8ifYCR9PXl7ppkgU3zvQtVtaD1RS7J/L4pwkzOsfKEfO7JVsS2xEK29y+MZYdtC+LoNrbGlJPm8iL7Dhw6uA83H5oHVFfqy+fqELVjuy7RefBmunA6vqojIQQDvrnhb/BFE9qBlHkoVqtZpUB8zRzYFFVoD/7oxtgSD4xmX1UVoLBCq0axMi93VPZvLuhYz49Y8s72RSnK+9wfeXuefH4XlePe8F64tQmu7MrqHejGMJHMn/1hebbSiikrr7D/udg+s5mhybQAAAABJRU5ErkJggg==);
  background-repeat: no-repeat;
  background-position: 100%;
  background-size: 16px 16px;
}

.prayer-container {
  margin: 16px 12px 0;
  background-color: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 16px 12px 8px;
}

.prayer-container .title-container .prayer-title {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  font-family: PingFangSC-Medium, PingFang SC;
  display: inline-block;
  z-index: 2;
}

.buyer-container .cell:not(:last-of-type),
.prayer-container .cell:not(:last-of-type) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.prayer-container .cell .van-field,
.prayer-container .cell-text-container .van-field {
  padding: 12px 0 !important;
}

.buyer-container .cell,
.money-container .cell,
.prayer-container .cell {
  line-height: 48px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-weight: 400;
}

.buyer-container .cell .label,
.money-container .cell .label,
.prayer-container .cell .label,
.use-date-wrap .label {
  width: 6.2em;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  margin-right: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
}

.choose-arrow {
  margin-top: 20px;
  width: 7px;
  height: 11px;
}

.prayer-container .van-field__label {
  width: 68px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  font-family: PingFangSC-Regular, PingFang SC !important;
}

.prayer-container .van-field__value {
  font-size: 14px;
  color: #000;
  margin-left: 20px;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  font-family: PingFangSC-Regular, PingFang SC !important;
}

.contact-card .cell .buyer-info-input {
  font-size: 14px;
  color: #000;
  margin-left: 20px;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  font-family: PingFangSC-Regular, PingFang SC;
}

.contact-checkBox {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
  letter-spacing: 0;
  font-weight: 400;
  line-height: 16px;
  height: 16px;
}

.contact-checkBox label {
  text-align: right;
  display: inline-block;
}
.regular-checkbox {
  text-align: right;
}

.van-checkbox__label {
  font-family: PingFangSC-Regular !important;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4) !important;
  letter-spacing: 0;
  font-weight: 400;
}

/* 新增弹出页面样式 ***************************/
.select-contact-container {
  background-color: #f3f4f5;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  -webkit-transition: -webkit-transform 0.5s;
  transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
  transition: transform 0.5s, -webkit-transform 0.5s;
  z-index: 400;
  height: 564px;
}

.select-contact-container > img {
  position: absolute;
  right: 16px;
  top: 22px;
  width: 10px;
}

.select-contact-container .select-contact-title {
  line-height: 54px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000;
  text-align: center;
}

.select-contact-container .scroll {
  height: 438px;
  overflow-y: auto;
}

.select-contact-container .scroll .increase {
  background-color: #fff;
  border-radius: 5px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #007aaa;
  margin: 0 12px 16px;
  padding: 10px 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.select-contact-container .scroll .increase > img {
  width: 15px;
  height: 15px;
  margin-right: 9px;
}

.select-contact-container .scroll .contact-wrap {
  background-color: #fff;
  border-radius: 8px;
  margin: 0 12px;
}

.select-contact-container .scroll .contact-wrap .contact-item:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.select-contact-container .scroll .contact-wrap .contact-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 8px 0;
  margin: 0 12px;
  border: none;
}

.select-contact-container .scroll .contact-wrap .contact-item .center {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  margin: 0 8px;
}

.select-contact-container .scroll .contact-wrap .contact-item .center div {
  display: block;
}

.select-contact-container .scroll .contact-wrap .contact-item .center .name {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000;
}

.select-contact-container
  .scroll
  .contact-wrap
  .contact-item
  .center
  .info-title {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.4);
}

.select-contact-container
  .scroll
  .contact-wrap
  .contact-item
  .center
  .info-content {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
}

.select-contact-container .scroll .contact-wrap .contact-item .right > img {
  width: 15px;
  height: 15px;
}

.select-contact-container .bottom-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 72px;
  background: #fff;
  -webkit-box-shadow: 0 1px 0 0 #eee;
  box-shadow: 0 1px 0 0 #eee;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.select-contact-container .bottom-wrap .confirm {
  background: linear-gradient(133deg, #007aaa, #004e93);
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 122, 170, 0.2);
  box-shadow: 0 0 8px 0 rgba(0, 122, 170, 0.2);
  border-radius: 22px;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  margin: 0 48px;
  text-align: center;
  padding: 9px 0;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
}
</style>